import getApiHttpClient from '../../../httpClients/getApiHttpClient';

import type { ExcessExportLink } from '../types';

export async function fetchExcessExportLink(id: string): Promise<ExcessExportLink> {
  const res = await getApiHttpClient().get<ExcessExportLink>(
    `/api/v1/cfo/capacity/excess/exports/${id}`,
  );
  return res.data;
}
